import React, { useMemo } from "react"

import { cloneDeep } from "lodash"

import { parseTimingFunction } from "../../utils"
import { useKeyframeConfig } from "../../utils/tailwindConfig/hooks"
import { ListContainer, Subtitle, ButtonSandbox } from "../components/tailwindSandbox"

import { useAnimation } from "./context"

const List = ({ items = [], index, custom, className }) => {
  const { onCloseContextMenu } = useAnimation()

  return <>
    <ListContainer className={`${className} p-1`} onCloseContextMenu={onCloseContextMenu}>
      {items.map(({ category, items }) => <div key={category}>
        <Subtitle subtitle={category} />
        <div className="flex gap-2 flex-wrap mb-2">
          {items.map(item => <Item index={index} key={item.name} item={item} custom={custom} />)}
        </div>
      </div>)}
    </ListContainer>
  </>
}

const Item = ({ item, index, custom }) => {
  const { animationState, setAnimationState } = useAnimation()
  const { value: keyframeConfig, setValue: setKeyframeConfig } = useKeyframeConfig()
  const { name: animationCraft, duration: durationCraft, delay: delayCraft, ease: easeCraft, loops: loopsCraft, direction: directionCraft, fill: fillCraft } = animationState[index]
  const { setAnimation: setAnimationContext, animation: animationContext } = useAnimation()

  const handleSelectKeyframe = () => {
    const value = animationCraft === item.name ? undefined : item.name
    handleChangeCraft(value)
    handleChangeKeyframeConfig(item)
  }

  const handleChangeCraft = value => {
    const newAnimations = cloneDeep(animationState)
    newAnimations[index].name = value
    setAnimationState(newAnimations)
  }

  const handleChangeKeyframeConfig = item => {
    const keyframeConfigParsed = Array.isArray(keyframeConfig) ? keyframeConfig : Object.keys(keyframeConfig)
    setKeyframeConfig([
      ...keyframeConfigParsed || [],
      keyframeConfigParsed.includes(item.name) ? undefined : item.name,
    ].filter(Boolean))
  }

  const handleRightClick = (item, event) => {
    event.preventDefault()
    setAnimationContext({ ...animationContext, rightClick: { selected: item, mouse: { x: event.clientX, y: event.clientY }, custom } })
  }

  const animateClass = useMemo(() => {
    const duration = durationCraft ? `${durationCraft}ms` : ''
    const delay = delayCraft ? `${delayCraft}ms` : ''
    const ease = parseTimingFunction(easeCraft, {})
    const animationConfig = [duration, ease, delay, loopsCraft, directionCraft, fillCraft].filter(Boolean).join('_')
    return `animate-[${item.name}_${animationConfig}]`
  }, [durationCraft, easeCraft, delayCraft, loopsCraft, directionCraft, fillCraft, item.name])

  return <>
    <div className="group cursor-pointer" onClick={handleSelectKeyframe} onContextMenu={e => handleRightClick(item, e)}>
      <ButtonSandbox
        size='sm'
        variant='outline'
        color='accent'
        active={item.name === animationCraft}
        className={`group-hover:${animateClass}`}
      >
        {item.name}
      </ButtonSandbox>
    </div>
  </>
}

export default List
